import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Container } from 'reactstrap';
import classNames from 'classnames';
import { QuizHeader } from './QuizHeader';
import { QuestionText } from './QuestionText';

export const WHOLE_BEANS_ANSWER = 'grind:Whole Bean;specificGrind:null';

const answers = [
  {
    name: 'Whole Beans',
    value: WHOLE_BEANS_ANSWER,
    event: {
      grind: 'Whole Beans',
    },
  },
  {
    name: 'Grind It For Me',
    value: 'grind:Ground',
    event: {
      grind: 'Ground',
    },
  },
];

const isGroundAnswer = answer => answer?.startsWith('grind:') && answer !== WHOLE_BEANS_ANSWER;

const isSelected = (savedAnswer, answer) =>
  answer.value === WHOLE_BEANS_ANSWER ? savedAnswer === answer.value : isGroundAnswer(savedAnswer);

export const Question2 = ({ index, total, displayIndex, displayTotal, onAnswer, answers: quizAnswers }) => {
  return (
    <>
      <QuizHeader
        index={displayIndex}
        total={displayTotal}
        quizAnswers={quizAnswers}
        description="Nice. You're off to a good start."
      />
      <QuestionText
        index={index}
        total={total - 1}
        title="Grind Preference"
        subtitle="Do you want whole beans, or should we grind them for you?"
      />
      <Container className="mt-4 px-0">
        <Row className="justify-content-center quiz-answer-row">
          {answers.map((answer, i) => (
            <Col key={i} xs="6" className="quiz-answer-col">
              <Card
                body
                tag="button"
                className={classNames(
                  'd-flex flex-md-row flex-column align-items-center justify-content-center w-100 answer',
                  {
                    'answer-selected': isSelected(quizAnswers?.[index], answer),
                  }
                )}
                onClick={() => onAnswer(answer)}
              >
                {isSelected(quizAnswers?.[index], answer) && <span className="quiz-answer-check">✓</span>}
                <div className="mb-0">{answer.name}</div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

Question2.propTypes = {
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  displayIndex: PropTypes.number.isRequired,
  displayTotal: PropTypes.number.isRequired,
  onAnswer: PropTypes.func.isRequired,
  answers: PropTypes.object,
};
